import axios from 'axios';
import { getAdminApiBaseUrl } from '../utils/adminApiBaseUrl';

export type HeroPaymentCycleFunnelTotals = {
  whatsapp_sent: number;
  whatsapp_messages: number;
  link_opened: number;
  link_page_views: number;
  payment_term_selected: number;
  payment_term_events: number;
  preferred_term_on_profile: number;
};

export type HeroPaymentCycleFunnelBucket = {
  period: string;
  period_start: string;
  whatsapp_sent: number;
  link_opened: number;
  payment_term_selected: number;
};

export type HeroPaymentCycleFunnelResponse = {
  campaign_id: string;
  campaign_label: string;
  from_date: string;
  to_date: string;
  period: string;
  totals: HeroPaymentCycleFunnelTotals;
  buckets: HeroPaymentCycleFunnelBucket[];
  notes: string[];
};

export async function fetchHeroPaymentCycleCampaignFunnel(params: {
  period: string;
  from_date: string;
  to_date: string;
}): Promise<HeroPaymentCycleFunnelResponse> {
  const apiBase = (getAdminApiBaseUrl() || '').replace(/\/?$/, '/');
  const response = await axios.get(`${apiBase}customers/campaign-funnels/hero-payment-cycle`, {
    params,
  });
  return response.data;
}
